import AddressInput from "@common/controls/Inputs/Text/Address";

export default AddressInput;
